import { render } from "./ApprovalHistory.vue?vue&type=template&id=a56b0d44"
import script from "./ApprovalHistory.vue?vue&type=script&lang=js"
export * from "./ApprovalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__